import { useId } from "react";

export function ScoreBar({ score, bands }: {
  score: number;
  bands: { label: string; max: number; colour: string }[];
}) {
  const maxScore = bands[bands.length - 1].max;
  const pct = Math.min((score / maxScore) * 100, 100);
  const band = bands.find((b) => score <= b.max) ?? bands[bands.length - 1];
  return (
    <div className="mt-3">
      <div className="flex justify-between text-xs text-slate-500 mb-1">
        <span>Score: <strong className="text-slate-900 text-sm">{score.toFixed(2)}</strong></span>
        <span className={`font-semibold ${band.colour}`}>{band.label}</span>
      </div>
      <div className="h-3 rounded-full bg-slate-100 overflow-hidden">
        <div
          className="h-full rounded-full bg-teal-600 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}

export function NumberInput({ label, value, onChange, min = 0, max, step = 1, hint }: {
  label: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  hint?: string;
}) {
  const id = useId();
  return (
    <div>
      <label htmlFor={id} className="block text-xs font-medium text-slate-700 mb-1">{label}</label>
      {hint && <p className="text-xs text-slate-500 mb-1">{hint}</p>}
      <input
        id={id}
        type="number"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
        className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
      />
    </div>
  );
}

export function VASSlider({ label, value, onChange, hint }: {
  label: string;
  value: number;
  onChange: (v: number) => void;
  hint?: string;
}) {
  const id = useId();
  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <label htmlFor={id} className="text-xs font-medium text-slate-700">{label}</label>
        <span className="text-sm font-bold text-teal-700 tabular-nums w-8 text-right">{value}</span>
      </div>
      {hint && <p className="text-xs text-slate-500 mb-1">{hint}</p>}
      <input
        id={id}
        type="range"
        min={0}
        max={10}
        step={0.5}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="w-full accent-teal-600"
      />
      <div className="flex justify-between text-xs text-slate-500 mt-0.5">
        <span>0 — None</span>
        <span>10 — Very severe</span>
      </div>
    </div>
  );
}
